import React from "react";
import { OpenhousePostProps } from "../../../listings/listing/types";
import CustomPosts from "../CustomPosts";

const VideoPost: React.FC<OpenhousePostProps> = ({
    setIsOpen,
    listing,
    open,
}) => {
    return (
        <CustomPosts
            setIsOpen={setIsOpen}
            listing={listing}
            open={open}
            isVideo={true}
        />
    );
};

export default VideoPost;
